import html2pdf from "html2pdf.js";
export const ExportToPDF = function (ref , fileName , pageSize , orientation) {
    var pageSizeFormat = 'a3';
    var orientationType = 'portrait';
    if (pageSize !== null || pageSize !== undefined) {pageSizeFormat = pageSize}
    if (orientation !== null || orientation !== undefined) {orientationType = orientation}
    html2pdf(ref, {
        margin: 0,
        filename: fileName,
        image: { type: "jpeg", quality: 0.98 },
        html2canvas: { scale: 4, dpi: 192, letterRendering: true },
        jsPDF: { unit: "in",format: 'a4', orientation: orientationType },
      });
}

  


export default {
    ExportToPDF,
}